export default __webpack_public_path__ + "static/media/JangoIcon.4708463f.png";